<div class="flex items-start gap-2 shrink-0">
  <app-layout-sidebar>
    <app-layout-sidebar-logo />
    <app-layout-sidebar-item-group
      class="flex-grow overflow-auto overflow-x-hidden scrollbar-custom -ml-2"
      style="
        overflow: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        -webkit-scrollbar: none;
      ">
      <ng-container *ngIf="hasAnyToolsPermissions()">
        <ng-container *ngFor="let item of sidebarItems">
          <app-layout-sidebar-item
            *appHasPermission="getItemPermissions(item)"
            [hasContent]="!!item.childrens && item.childrens.length > 0"
            [icon]="item.icon"
            [label]="item.title"
            [link]="!item.childrens ? item.route : undefined">
            <ng-container *ngIf="item.childrens && item.childrens.length > 0">
              <div class="flex gap-2 pl-4 py-2">
                <div
                  class="w-[2px] bg-white self-stretch ml-1 flex-shrink-0 rounded-full"></div>
                <div class="flex flex-col gap-1 flex-1">
                  <ng-container *ngFor="let child of item.childrens">
                    <a
                      *appHasPermission="child.permission"
                      [routerLink]="child.route"
                      routerLinkActive="text-primary-300"
                      class="text-white font-normal py-1.5 px-2 hover:bg-primary-800 rounded-md transition-colors">
                      {{ child.title }}
                    </a>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </app-layout-sidebar-item>
        </ng-container>
      </ng-container>
    </app-layout-sidebar-item-group>
  </app-layout-sidebar>
  <main
    class="flex flex-col max-h-screen justify-between duration-200 ease-in-out ml-[70px] w-full min-w-0"
    [class.md:ml-60]="!(sidebarService.$collapsed | async)">
    <app-layout-topbar
      class="block px-9 pt-6 pb-2 z-40 transition-all duration-200"
      [class.bg-primary]="isScrolled()"
      [class.shadow-md]="isScrolled()" />
    <div
      class="flex-auto overflow-y-auto min-w-0 px-9 pb-20"
      (scroll)="onMainScroll($event)">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
